import React, {Fragment, useState} from 'react';
import {intlShape, injectIntl} from 'react-intl';
import {compose} from 'redux';
import {Form as FinalForm} from 'react-final-form';
import {connect} from "react-redux";

import {
  getProposalAmountWithCustomerFee,
  getProposalAmountWithProviderFee,
} from '../../../../util/transactions';
import {
 FieldStepperEditable, Form, SecondaryButton, PrimaryButton,
} from '../../../../components';
import css from './AskForProposal.module.css';
import * as validators from "../../../../util/validators";
import {sendOfferInvitation} from "../../../../ducks/transaction.duck";
import {bookingAskForProposalFromProviderEventType} from "../../../../util/eventsHelpers/constants";

const AskForProposal = (props) => {
  const {
    intl,
    onSendOfferInvitation,
    transactionId,
  } = props;
  const [isMakingAnOffer, setIsMakingAnOffer] = useState(false);
  const priceValidators = validators.minNumberAsString(
    1,
    intl.formatMessage(
      {id: 'ActivityFeed.proposalInvalid'},
      {price: '1€'},
    )
  );
  const onSubmit = (values) => {
    console.log('onSubmit', values);
    const proposalPriceAmount = values.proposalPrice * 100;
    const proposal = {
      price: getProposalAmountWithCustomerFee(getProposalAmountWithProviderFee(proposalPriceAmount)),
      initialPrice: proposalPriceAmount,
    };
    const text = `__proposal:${proposal}:proposal__`;
    console.log("handleOfferFromProvider", text);
    onSendOfferInvitation(transactionId, proposal)
      .then((messageId) => {
        setIsMakingAnOffer(false);
      })
      .catch(() => {
      });
  }

  return (
    !isMakingAnOffer ? (
      <SecondaryButton
        className={css.submitButton}
        type={'button'}
        onClick={() => setIsMakingAnOffer(true)}
      >
        {intl.formatMessage(
          {
            id: `BookingPanel.BookingForm.MakeAnOffer`
          }
        )}
      </SecondaryButton>
    ) : (
      <FinalForm
        initialValues={{}}
        onSubmit={(values) => onSubmit(values)}
        render={formRenderProps => {
          const {
            active,
            form,
            handleSubmit,
            values
          } = formRenderProps;
          return (
            <Fragment>
              <Form id="bookingForm" onSubmit={handleSubmit} className={css.proposalForm}>
                <FieldStepperEditable
                  className={css.fieldStepper}
                  inputClassName={css.fieldStepperInput}
                  name="proposalPrice"
                  label={intl.formatMessage(
                    {
                      id: `BookingPanel.BookingForm.proposalPriceLabel`
                    })}
                  initialValue={10}
                  min={1}
                  placeholder={intl.formatMessage({id: 'BookingPanel.BookingForm.enterProposalAmount'})}
                  validate={priceValidators}
                />
                <PrimaryButton
                  className={css.submitButton}
                  type={'submit'}
                >
                  {intl.formatMessage(
                    {
                      id: `BookingPanel.BookingForm.submitWithProposal`
                    },
                    {price: 'formattedPrice'}
                  )}
                </PrimaryButton>
              </Form>
            </Fragment>
          )
        }}
      />
    ))
};

AskForProposal.defaultProps = {
  intl: null,

};

AskForProposal.propTypes = {
  intl: intlShape.isRequired,

};

const mapDispatchToProps = (dispatch) => {
  return {
    onSendOfferInvitation: (txId, proposal) => dispatch(sendOfferInvitation(txId, proposal)),
  };
};

export default compose(
  connect(null, mapDispatchToProps),
  injectIntl
)(AskForProposal);
